<template>
  <div
    :class="[
      'w-full',
      red ? 'new-card-pink' : 'new-card',
      showTitle == false ? 'rounded-when-no-title' : '',
    ]"
  >
    <div
      v-if="showTitle"
      class="w-full text-left px-4 py-2 mb-4 new-card-title"
    >
      {{ title }}
    </div>
    <div
      :class="[
        'px-4',
        'py-2',
        showTitle == false ? 'rounded-when-no-title shadow-in' : '',
      ]"
    >
      <slot />
    </div>
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  export default {
    name: 'QuoterCard',
    props: {
      title: {
        type: String,
      },
      showTitle: {
        type: Boolean,
        default: true,
      },
      red: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style>
  .new-card {
    box-shadow: -1px 0px 8px 1px #bdbdbd;
    -webkit-box-shadow: -1px 0px 8px 1px #bdbdbd;
    -moz-box-shadow: -1px 0px 8px 1px #bdbdbd;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .new-card-pink {
    box-shadow: -1px 0px 8px 1px pink;
    -webkit-box-shadow: -1px 0px 8px 1px pink;
    -moz-box-shadow: -1px 0px 8px 1px pink;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .new-card-title {
    background-color: #fff;
    border-bottom: 4px solid #616161;
    color: #000;
    font-size: 0.9em;
    font-weight: bold;
    box-shadow: -1px 0px 20px 0px #bdbdbd inset;
    -webkit-box-shadow: -1px 0px 20px 0px #bdbdbd inset;
    -moz-box-shadow: -1px 0px 20px 0px #bdbdbd inset;
  }

  .rounded-when-no-title {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .shadow-in {
    box-shadow: inset 0px 3px 6px #00000029, 0px 3px 6px #00000029;
  }
</style>
